const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.dinezi.com';

const translationCache = new Map();

export const fetchTranslationFile = async (languageCode) => {
  try {
    // Check cache first
    if (translationCache.has(languageCode)) {
      return translationCache.get(languageCode);
    }

    const response = await fetch(`${API_BASE_URL}/api/common/languages/content/${languageCode}?platform=web`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch translation file for ${languageCode}`);
    }

    const result = await response.json();
    
    if (result.success) {
      // Cache the result
      translationCache.set(languageCode, result.data.content);
      return result.data.content;
    } else {
      throw new Error(result.message || 'Failed to fetch translation file');
    }
  } catch (error) {
    console.error(`Error fetching translation file for ${languageCode}:`, error);
    // Return null to indicate failure
    return null;
  }
};

export const fetchAllLanguageFiles = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/api/common/languages/files?platform=web`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch language files');
    }

    const result = await response.json();
    return result.success ? result.data : [];
  } catch (error) {
    console.error('Error fetching language files:', error);
    return [];
  }
};

export const clearTranslationCache = () => {
  translationCache.clear();
};

export const getCachedTranslation = (languageCode) => {
  return translationCache.get(languageCode);
};

export const isTranslationCached = (languageCode) => {
  return translationCache.has(languageCode);
};
